import React, { useState} from 'react'
import Modal from "../components/Modal";
import { useTranslation } from "react-i18next";
import RoiCalculatorWidget from '../components/RoiCalculatorWidget';

const Ecommerce_new = () => {
  const { t, i18n } = useTranslation();
  const [language, setLenguage] = useState("es");
  const [isOpen, setIsOpen] = useState(false);
  const SVG_OVERLAY_URL = "https://img.invupos.com/clauweb/Hero/Vector%20128.svg";

  const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/clauweb/Empresas/stevens.png", alt: "Stevens" },
      { src: "https://img.invupos.com/clauweb/Empresas/Powertranz.png", alt: "Powertranz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Grand-deli-gourmet.png", alt: "Grand Deli Gourmet" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/clauweb/Empresas/sugoi.png", alt: "Sugoi" },
      { src: "https://img.invupos.com/clauweb/Empresas/Cafe%20duran.png", alt: "Café Durán" },
      { src: "https://img.invupos.com/clauweb/Empresas/Madison.png", alt: "Madison" },
      { src: "https://img.invupos.com/clauweb/Empresas/XING%20FU%20TANG.png", alt: "Xing Fu Tang" },
      { src: "https://img.invupos.com/clauweb/Empresas/Leto.png", alt: "Leto" },
  
      // === Los que ya tenías ===
      // { src: "https://img.invupos.com/clauweb/Partners/logos/cinnabon-1.webp", alt: "Cinnabon" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Sushiexpress1.webp", alt: "Sushi Express" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Elcosto.webp", alt: "El Costo" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Grupotova.webp", alt: "Grupo Tova" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/CredicorpBank_logo.webp", alt: "Credicorp Bank" },
      // { src: "https://img.invupos.com/clauweb/Partners/Tsugoi.webp", alt: "Tsugoi" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/FDCenter_logo.webp", alt: "FDCenter" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Bravapizza_logo.webp", alt: "Brava Pizza" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain 
  
                      transition-all duration-300 ease-in-out
                      ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <div className='bg-gradient-to-b bg-gradient-to-b from-[#040309] via-[#171635] to-[#2A255B]'>
        <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2 items-center">
            <div className="relative overflow-hidden lg:order-last order-last flex flex-col rounded-3xl drop-shadow-[0_10px_20px_rgba(236,57,42,0.25)]">
              <img
                alt="Wallet Digital"
                src="https://img.invupos.com/clauweb/Ecommerce_new/E-commerce_new_1_hezhau.png"
                className="object-cover w-full h-full sm:h-full"
              />
            </div>
            <div className="lg:py-28 text-left">
              <h1 className="text-7xl font-extrabold sm:text-[85px] text-white">
                <span className="block">{t("clauecommerceuppercase")}</span>
                <span
                  className="mt-4 w-full ml-auto px-12 py-4 rounded-r-full text-white lg:text-7xl text-5xl font-bold flex items-center justify-end"
                  style={{ background: "linear-gradient(to right, white, #A9A8EE, #9290EA)" }}
                >
                  {t("clauecommercetitlespan")}
                </span>
              </h1>
              <p className="mt-8 text-gray-100 text-2xl w-full tracking-normal leading-relaxed">
                {t("clauecommercedescription")}
              </p>
              <div className="mt-8">
                <button
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-16 py-4 text-lg font-medium text-[#1F2331] hover:bg-transparent hover:text-[#fff] focus:ring-3 focus:outline-hidden"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("clauecommercecta")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

<section className="relative w-full flex items-center overflow-hidden pt-10">
  
  
  <div className="w-full max-w-screen-2xl mx-auto px-6">
    
    {/* 👇 Cambiamos proporción del grid */}
    <div className="grid lg:grid-cols-[45%_55%] items-center gap-10">

      {/* LEFT */}
      <div className="max-w-3xl z-10">

        <h1 className="text-4xl md:text-5xl xl:text-[65px] font-medium text-[#0B2B5C] leading-[1.15] mb-6">
          <span className="text-[#EC392A] font-extrabold">
            {t("ECOM_HERO_TITLE_HIGHLIGHT")}
          </span>{" "}
          {t("ECOM_HERO_TITLE_LINE")}
        </h1>

        <p className="text-gray-600 text-base md:text-lg mb-8 max-w-2xl">
        {t("ECOM_HERO_DESCRIPTION")}
        </p>

        <button 
          onClick={() => {
            setIsOpen(true);
          }}
        className="bg-[#E73829] hover:bg-[#ff5a4c] transition text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg">
        {t("ECOM_HERO_BUTTON")}
        </button>
      </div>

      {/* RIGHT */}
      {/* <div className="relative flex justify-end">
        <img
          src="https://img.invupos.com/clauweb/Hero/Group%201597880418.png"
          alt="Clau App"
          className="w-[120%] max-w-none translate-x-10 drop-shadow-2xl"
        />
      </div> */}


<div className="relative flex justify-center lg:justify-center">

{/* 🎨 LÍNEAS */}
<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-3.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-20
    w-[110%] sm:w-[115%] lg:w-[117%] max-w-none
    animate-lineDrawBlue
  "
/>

<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-4.png"
  alt=""
  className="
    absolute top-0 

    lg:left-auto lg:right-0 lg:translate-x-20

    w-[110%] sm:w-[115%] lg:w-[117%] max-w-none
    animate-lineDrawRed
  "
/>

{/* 🧱 IMAGEN 1 */}
<div className="relative w-[100%] sm:w-[50%] lg:w-[90%] mx-auto aspect-square overflow-hidden">
  <img
    src="https://img.invupos.com/clauweb/Ecommerce_new/E-commerce_new_1_hezhau.png"
    alt="Clau App"
    className="
     relative z-10
    w-[70%] sm:w-[50%] lg:w-[67%] max-w-none
    mx-auto
   lg:-left-10
    lg:translate-x-10
    opacity-0 animate-img1 
    "
  />
</div>
</div>
    </div>
  </div>
</section>


<section>
        <div className="lg:mt-0 mt-10 mx-auto max-w-screen-2xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>


      <div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-2xl lg:px-8 lg:py-10 lg:mt-12">
        <div className="p-8 rounded-3xl sm:p-12 bg-[#F1F1F1]">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1d1d1f]">
           {t("clauecommerceexperiencetitle")}
          </h2>
          <div className="flex flex-col items-center justify-between lg:flex-row mt-8 rounded-3xl bg-[#F1F1F1] lg:gap-12">
            {/* Lado izquierdo - Imagen del combo */}
            <div className="relative lg:w-1/2 mb-8 lg:mb-0 ">
              <img
                className="lg:w-full lg:h-full rounded-2xl object-cover object-top"
                src="https://img.invupos.com/clauweb/Ecommerce_new/eathh-mockup_1_mxcbg4.png"
                alt="Combo del día"
              />
            </div>

            {/* Lado derecho - Texto y lista */}
            <div className="lg:max-w-xl lg:pl-10 p-8">
              <ul className="space-y-8 text-gray-700 text-2xl list-disc">
                <li>
                  <span className="font-bold ">
                    {t("clauecommercialyticstitle")}:
                  </span>{" "} {t("clauecommercialyticsdescription")}
                  <br />
                </li>
                <li>
                  <span className="font-bold ">
                    {t("clauecommercesupporttitle")}:
                  </span>{" "} {t("clauecommercesupportdescription")}
                  <br />
                </li>
                <li>
                  <span className="font-bold ">
                    {t("clauecommercepromotionstitle")}:
                  </span>{" "} {t("clauecommercepromotionsdescription")}
                  <br />
                </li>
                <li>
                  <span className="font-bold ">
                    {t("clauecommerceloyaltyprogramtitle")}:
                  </span>{" "} {t("clauecommerceloyaltyprogramdescription")}
                  <br />
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Tarjetas informativas pequeñas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 text-center">
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[200px] mx-auto">
              {t("clauecommercefeaturepaymentgateways")}{" "}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauecommercefeaturepaymentgatewaysdescription")}
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[180px] mx-auto">
             {t("clauecommercefeatureshipping")}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauecommercefeatureshippingdescription")}
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[220px] mx-auto">
              {t("clauecommercefeatureposintegration")}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauecommercefeatureposintegrationdescription")}
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-2xl lg:px-8 lg:py-20">
        <div className="grid gap-12 row-gap-8 lg:grid-cols-2">
          <div className="flex flex-col justify-center">
            <div className="max-w-2xl mb-6">
              <h2 className="max-w-lg mb-6 font-sans text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl sm:leading-none">
                {t("clauecommercemobileadaptationtitle")}
              </h2>
              <p className="mt-8 text-gray-500 text-2xl w-full tracking-normal leading-relaxed">
                {t("clauecommercemobileadaptationdescription")}
              </p>
            </div>
            <div className="grid gap-6 row-gap-6 sm:grid-cols-2">
              <div className="relative p-6 bg-[#FE7066] border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20129%281%29.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-16"
                />
                <div className="relative z-10 space-y-4">
                  <span className="text-5xl font-semibold text-white">80%</span>
                  <h3 className="inline-block mb-3 text-2xl font-bold text-white transition-colors duration-200 hover:text-deep-purple-accent-400">
                    {t("clauecommercespeeddescription")}
                  </h3>
                </div>
              </div>

              <div className="p-6 bg-white border rounded-3xl shadow-sm space-y-4 items-center flex">
                <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                  {t("clauecommercemetrics")}
                </h3>
              </div>

              <div className="relative p-6 bg-white border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20128.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-10"
                />
                <div className="relative z-10 space-y-4">
                  <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                    {t("clauecommerceinstantpayments")}
                  </h3>
                </div>
              </div>

              <div className="relative p-6 bg-white border rounded-3xl shadow-sm overflow-hidden space-y-4">
                <img
                  src="https://img.invupos.com/clauweb/E-commerce/Vector%20130.svg"
                  alt="Decorative background"
                  className="absolute inset-0 w-full h-full object-cover z-0 mt-4"
                />

                <div className="relative z-10 space-y-4">
                  <h3 className="inline-block mb-3 text-4xl font-semibold text-[#25272D] transition-colors duration-200 hover:text-deep-purple-accent-400">
                    {t("clauecommercesordertracking")}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover w-full h-full  sm:h-full"
              src="https://img.invupos.com/clauweb/Ecommerce_new/Sky_kitchens_sushi_express_pnuryb.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="bg-white">
  <div className="max-w-screen-2xl px-6 py-4 mx-auto mb-10">
    <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1d1d1f] py-6 text-left md:text-center lg:text-left">
      {t("clauecommercesalestitle")}{" "}
      <span className="text-[#FE7066]">CLAU.IO</span>
    </h2>
    <div className="relative z-20 w-full mt-4 md:flex md:items-center xl:mt-8">
      <div className="absolute w-full border border-gray-100  -z-10 md:h-[360px] rounded-3xl"></div>
      <div className="w-full p-4  md:flex md:items-center rounded-2xl md:bg-transparent md:p-0 lg:px-8 md:justify-evenly">
        <div className="mt-2 md:mx-4 md:w-1/2">
          <p className="font-light text-xl tracking-normal leading-relaxed text-gray-700 max-w-xl">
            {t("clauecommerceloyaltytitle")}.{" "}
            {t("clauecommerceloyaltydescription")}
          </p>
          <button
            onClick={() => setIsOpen(true)}
            className="mt-4 inline-block rounded-full border border-[#FE7066] bg-[#FE7066] lg:px-10 px-6 py-2 text-sm md:text-lg font-medium text-white hover:bg-transparent hover:text-[#FE7066] focus:ring-3 focus:outline-hidden"
          >
            {t("clauecommerceloyaltycta")}
          </button>
        </div>
        <img
          className="md:mx-4 lg:mt-0 mt-8 object-cover md:h-[18rem] md:w-[28rem] lg:h-[30rem] lg:w-[36rem] rounded-2xl"
          src="https://img.invupos.com/clauweb/Ecommerce_new/Sushi_Express_Desktop_w0qsrw.png"
          alt="client photo"
        />
      </div>
    </div>
  </div>
</div>

<RoiCalculatorWidget/>

    {isOpen && <Modal setIsOpen={setIsOpen} />}
      
    </>
  );
};

export default Ecommerce_new;